import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Modal, ButtonBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ZoomInIcon from '@material-ui/icons/ZoomIn';

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
  },
  image: {
    display: 'block',
  },
  zoomIcon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  modalImage: {
    maxWidth: '90vw',
    maxHeight: '90vh',
    objectFit: 'contain',
  },
}));

export default function ImageViewer({ src, width, height, alt = 'Preview' }) {
  const classes = useStyles();
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const handleClick = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);
  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <ButtonBase
        className={classes.imageContainer}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        onKeyPress={handleKeyPress}
        tabIndex={0}
        aria-label={`View larger version of ${alt}`}
      >
        <img
          src={src}
          alt={alt}
          width={width}
          height={height}
          className={classes.image}
        />
        {isHovered && (
          <IconButton className={classes.zoomIcon} size="small">
            <ZoomInIcon />
          </IconButton>
        )}
      </ButtonBase>

      <Modal
        open={isModalOpen}
        onClose={handleClose}
        className={classes.modal}
        onClick={handleClose}
      >
        <ButtonBase
          onClick={(e) => e.stopPropagation()}
          onKeyPress={(e) => e.stopPropagation()}
          tabIndex={0}
          aria-label={`Close enlarged view of ${alt}`}
        >
          <img src={src} alt={alt} className={classes.modalImage} />
        </ButtonBase>
      </Modal>
    </>
  );
}

ImageViewer.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  alt: PropTypes.string,
};

ImageViewer.defaultProps = {
  alt: 'Preview',
};
